import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { DesyAngularModule } from 'desy-angular';
import { HeaderComponent } from './components/header/header.component';
import { FileUploaderComponent } from './components/file-uploader/file-uploader.component';
import { CardsComponent } from './components/cards/cards.component';
import { PageFooterComponent } from './components/page-footer/page-footer.component';
import { HeaderActionsComponent } from './components/header-actions/header-actions.component';
import { IconTrashComponent } from './components/icon-trash/icon-trash.component';
import { NotificationComponent } from './components/notification/notification.component';
import { PaginationComponent } from './components/pagination/pagination.component';
import { DonwnloadCVComponent } from './components/download-cv/download-cv.component';
import { JobseekerDialogComponent} from './components/jobseeker-dialog/jobseeker-dialog.component';
import { ImageOptionsComponent } from './components/image-options/image-options.component';
import { ReactiveFormsModule } from '@angular/forms';
import { WeightSliderComponent } from './components/weight-slider/weight-slider.component';
import { JobOfferDialogComponent } from './components/job-offer-dialog/job-offer-dialog.component';
import { AccessibilityComponent } from './components/accessibility/accessibility.component';
import { SitemapComponent } from './components/sitemap/sitemap.component';
import { UnauthorizedComponent } from './components/unauthorized/unauthorized.component';

@NgModule({
  declarations: [
    HeaderComponent,
    FileUploaderComponent,
    CardsComponent,
    PageFooterComponent,
    IconTrashComponent,
    NotificationComponent,
    HeaderActionsComponent,
    PaginationComponent,
    DonwnloadCVComponent,
    JobseekerDialogComponent,
    JobOfferDialogComponent,
    ImageOptionsComponent,
    WeightSliderComponent,
    AccessibilityComponent,
    SitemapComponent,
    UnauthorizedComponent
  ],
  imports: [CommonModule, DesyAngularModule, ReactiveFormsModule],
  exports: [
    HeaderComponent,
    FileUploaderComponent,
    CardsComponent,
    PageFooterComponent,
    IconTrashComponent,
    NotificationComponent,
    HeaderActionsComponent,
    PaginationComponent,
    DonwnloadCVComponent,
    JobseekerDialogComponent,
    JobOfferDialogComponent,
    ImageOptionsComponent,
    WeightSliderComponent,
    AccessibilityComponent,
    SitemapComponent,
    UnauthorizedComponent
  ],
})
export class SharedModule {}
